export class User {
    user_id: number; 
    email: string;
    nombre: string;
    password: string;
    activo: number;
}
